import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@core/components/base/base.component';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Component({
  selector: 'app-offer-error',
  templateUrl: './offer-error.component.html',
  styleUrls: ['./offer-error.component.scss'],
})
export class OfferErrorComponent extends BaseComponent implements OnInit {
  planNumber: string;

  constructor(
    private readonly viewOffersService: ViewOffersService,
    private readonly route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.route.queryParams
      .pipe(
        take(1),
        switchMap(({ plan_number }) =>
          plan_number
            ? of(plan_number)
            : this.viewOffersService.currentPlan$.pipe(take(1))
        )
      )
      .subscribe((plan) => {
        this.planNumber = typeof plan === 'string' ? plan : plan?.plan_number;
      });
  }
}
